// src/VouchersModal.js

import React, { useState, useRef } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, IconButton, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Vouchers from './Vouchers';

// Imports para gerar PDF
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const VouchersModal = ({ open, onClose, reserva, hospede }) => {
  const [loadingPdf, setLoadingPdf] = useState(false);
  const vouchersRef = useRef(null);

  const handleGerarPDF = async () => {
    setLoadingPdf(true);
    const input = vouchersRef.current;
    if (input) {
      try {
        const canvas = await html2canvas(input, { scale: 2 }); // Aumentar a escala melhora a resolução
        const imgData = canvas.toDataURL('image/png');
        
        const pdf = new jsPDF({
          orientation: 'portrait',
          unit: 'mm',
          format: 'a4'
        });

        const pdfWidth = pdf.internal.pageSize.getWidth();
        // Calcula a altura mantendo a proporção da imagem original
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
        
        // --- MELHORIA 2: Adiciona a imagem usando a largura total para manter a proporção ---
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        
        // --- CORREÇÃO 1: Usa hospede.nome para o nome do arquivo ---
        pdf.save(`Vouchers-${hospede.nome}.pdf`);

      } catch (error) {
        console.error("Erro ao gerar PDF dos vouchers:", error);
      } finally {
        setLoadingPdf(false);
      }
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Visualizar Vouchers de Acesso
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {/* A referência agora está no componente que renderiza o conteúdo visual */}
        <div ref={vouchersRef}>
          <Vouchers reserva={reserva} hospede={hospede} />
        </div>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="outlined" color="inherit">Fechar</Button>
        <Button 
          onClick={handleGerarPDF} 
          variant="contained" 
          startIcon={loadingPdf ? <CircularProgress size={20} color="inherit" /> : <PictureAsPdfIcon />}
          disabled={loadingPdf}
        >
          {loadingPdf ? 'Gerando...' : 'Gerar PDF'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VouchersModal;